<template>
    <!--<a :href="getDraftUrl">Kladd URL</a>-->
    <section :class="hideStep0">
        <div v-if="schoolHasActiveCourses && schoolAcceptApplications">
            <div v-if="localeIsEnglish" class="form__intro" v-html="globals.application_intro_english"></div>
            <div v-else class="form__intro">
                <div v-html="globals.form_intro"></div>
                <a v-if="globals.form_intro_button_no" class="form__intro--button" :href="`/school/${school?.slug}/application?language=en`" @click="clickedIntroButton = true" v-html="globals.form_intro_button_no"></a>
            </div>
            <div v-if="displayWaitinglistNotise && !localeIsEnglish && school.texts.waiting_list_no" class="form__notice form__notice--fullwidth">
                <h3>Venteliste</h3>
                {{ school.texts.waiting_list_no }}
            </div>
            <div class="form__required-intro" v-html="$t('formIntroRequired')"></div>
            <course-selector
                :locale="$i18n.locale"
                :courses="school?.courses"
                :courseTypes="courseTypes"
                :courseTypeError="courseTypeError"
                :courseType2Error="courseType2Error"
                :urlCourses="selectedCourses"
                :urlCourseType="selectedCourseType"
                :selectedCourses="selectedCourses"
                :globals="globals"
                @updateSelectedCourseType="updateSelectedCourseType"
                @updateSelectedCourses="updateSelectedCourses">
            </course-selector>
            <!--
            <course-plus-selector
                v-if="school?.coursesPlus?.length > 0"
                :locale="$i18n.locale"
                :courses="school?.coursesPlus"
                :selectedCourses="selectedCoursesPlus"
                @updateSelectedCourses="updateSelectedCoursesPlus">
            </course-plus-selector>
            -->
            <input-group
                v-for="inputgroup in inputgroupsApplication"
                :key="inputgroup.id"
                :inputgroup="inputgroup"
                :selectedOptions="applicationForm.input.options"
                @addFileToForm="addFileToForm"
                @inputValue="updateInputValue"
                @inputOptions="updateInputOptions">
            </input-group>
            <button class="form__button" v-on:click="viewNext">{{ $t("formPageNext") }}</button>
        </div>
        <div v-if="!schoolHasActiveCourses" class="form__notice form__notice--fullwidth">
            <h3>{{$t("errorNoOpenCoursesHeadline")}}</h3>
            <p>{{$t("errorNoOpenCourses")}}</p>
        </div>
        <div v-if="!schoolAcceptApplications" class="form__notice form__notice--fullwidth">
            <h3>English speakers not accepted</h3>
            <p>Sorry, this school does not accept English speaking students. Please try another school from the list.</p>
        </div>
    </section>

    <section :class="hideStep1">
        <input-group
            v-for="inputgroup in inputgroupsSchool"
            :key="inputgroup.id"
            :inputgroup="inputgroup"
            :selectedOptions="applicationForm.input.options"
            @addFileToForm="addFileToForm"
            @inputValue="updateInputValue"
            @inputOptions="updateInputOptions">
        </input-group>
        <button class="form__button" v-on:click="viewNext">{{ $t("formPageNext") }}</button>
        <button class="form__button form__button--back" style="margin-right: 16px" v-on:click="viewBack">{{ $t("formPagePrevious") }}</button>
        <div>
            <span class="form__explanation" >{{ $t("formExplanationSoonFinished") }}</span>
        </div>
        <div>
            <span class="form__continue-text">{{ $t("formDraftUrlText") }} <b><a href="" @click="openDraftModal">{{ $t("formDraftUrlLink") }}</a></b></span>
        </div>
    </section>

    <section :class="hideStep2">
        <h2>{{ $t("formHeadlineSummary")}}</h2>
        <div class="form__preview-wrapper">

            <div v-if="school" class="form__preview-field">
                <h3>{{ $t("formHeadlineSummarySchool")}}</h3>
                <p>{{ school.name }}</p>
            </div>

            <div class="form__preview-field" v-if="selectedCoursesData?.length && selectedCourseType">
                <div v-for="courseType in selectedCoursesData">
                    <h3 v-if="locale == 'no'">{{ courseType.type?.name_no }}</h3>
                    <h3 v-if="locale == 'en'">{{ courseType.type?.name_en }}</h3>
                    <ol>
                        <li v-if="locale == 'no'" v-for="course in courseType.courses">{{ course.name_no }}</li>
                        <li v-if="locale == 'en'" v-for="course in courseType.courses">{{ course.name_en ? course.name_en :course.name_no }}</li>
                    </ol>
                </div>
            </div>

            <div class="form__preview-field" v-if="selectedCoursesPlus?.length && selectedCoursesPlus[0] != 0">
                <h3>{{ $t("formHeadlineSummaryCoursePlus")}}</h3>
                <ol>
                    <li v-for="course in selectedCoursesPlus">{{ getCoursePlusName(course) }}</li>
                </ol>

            </div>

            <!-- Required fields -->
            <div v-for="inputGroups in inputgroupsApplication">
                <div v-for="inputGroup in inputGroups">
                    <div v-for="input in inputGroup">
                        <div v-if="input.value" class="form__preview-field">
                            <h3>{{ input.name }}</h3>
                            <ul v-if="input.type_id == 7"> <!-- File uploads -->
                                <li v-for="fileName in JSON.parse(input.value)">{{ fileName }}</li>
                            </ul>
                            <ul v-else-if="input.type_id == 9"> <!-- Zipcode -->
                                <li v-for="value, key in JSON.parse(input.value)">{{ $t(key) }}: {{ value }}</li>
                            </ul>
                            <p v-else>{{ input.value }}</p>
                        </div>
                        <div v-if="input.inputoptions?.length && getSelectedOptions(input.inputoptions)?.length" class="form__preview-field">
                            <h3>{{ input.name }}</h3>
                            <ul>
                               <li v-for="inputIption in getSelectedOptions(input.inputoptions)">
                                    <span>{{ inputIption }}</span>
                               </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Optional fields -->
            <div v-for="inputGroups in inputgroupsSchool">
                <div v-for="inputGroup in inputGroups">
                    <div v-for="input in inputGroup">
                        <div v-if="input.value" class="form__preview-field">
                            <h3>{{ input.name }}</h3>
                            <ul v-if="input.type_id == 7"> <!-- File uploads -->
                                <li v-for="fileName in JSON.parse(input.value)">{{ fileName }}</li>
                            </ul>
                            <ul v-else-if="input.type_id == 9"> <!-- Zipcode -->
                                <li v-for="value, key in JSON.parse(input.value)">{{ $t(key) }}: {{ value }}</li>
                            </ul>
                            <p v-else>{{ input.value }}</p>
                        </div>
                        <div v-if="input.inputoptions?.length && getSelectedOptions(input.inputoptions)?.length" class="form__preview-field">
                            <h3>{{ input.name }}</h3>
                            <ul>
                               <li v-for="inputIption in getSelectedOptions(input.inputoptions)">
                                    <span>{{ inputIption }}</span>
                               </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <button class="form__button" v-on:click="viewNext">{{ $t("formButtonSubmit") }}</button>
        <button class="form__button form__button--back" style="margin-right: 16px" v-on:click="viewBack">{{ $t("formPagePrevious") }}</button>
        <div>
            <span class="form__explanation" >{{ $t("formExplanationApply") }}</span>
        </div>
        <div>
            <span class="form__continue-text">{{ $t("formDraftUrlText") }} <b><a href="" @click="openDraftModal">{{ $t("formDraftUrlLink") }}</a></b></span>
        </div>
    </section>
    <section :class="hideStep3">
        <div class="form__loading-wrapper">
            <div class="form__loading-spinner">
                <div class="formSpinner"></div>
            </div>
            <p>{{ $t("formSubmittingText")  }}</p>
        </div>
    </section>
    <section :class="hideStep4">
        <div class="form__completed-wrapper">
            <div v-if="localeIsEnglish">
                <h2 class="form__completed-headline">{{ $t("formSubmitSuccessHeadline") }}</h2>
                <p>{{ $t("formSubmitSuccessText") }}</p>
            </div>
            <div v-else v-html="outroText"></div>
            <hr>
            <p><a :href="recieptUrl">{{ $t("formRecieptText") }} »</a></p>
            <p><a :href="schoolUrl">{{ $t("readMoreAboutSchool") }} »</a></p>
        </div>
    </section>
    <draft-email-modal
        v-if="draftModalOpen"
        :email="submissionEmail"
        @closeDraftModal="draftModalOpen = false"
        @send-draft-email="sendDraftEmail"
    ></draft-email-modal>
</template>


<script>
import '../../vanilla/application-source.js';
import axios from 'axios';
import { useI18n } from 'vue-i18n'
import { ref, reactive, computed, onMounted, onBeforeMount } from 'vue';
import fnrvalidator from '@navikt/fnrvalidator';
import { validateCapcha } from './components/reacaptcha.js';
import { validateInput } from './components/inputValidation.js';
import { scrollTop, scrollIntoView } from './components/scrolling.js';
import InputGroup from './views/InputGroup.vue';
import CourseSelector from './views/CourseSelector.vue';
import CoursePlusSelector from './views/CoursePlusSelector.vue';
import DraftEmailModal from './views/DraftEmailModal.vue';
import * as Sentry from "@sentry/vue";

// Input type IDs
const TEXT                   = 0;
const TEXTAREA               = 1;
const NUMBER                 = 2;
const SELECT                 = 3;
const RADIO                  = 4;
const CHECKBOX               = 5;
const DATE                   = 6;
const FILE                   = 7;
const SOCIAL_SECURITY_NUMBER = 8;
const ZIP_CODE               = 9;
const EMAIL                  = 10;
const PHONE_NUMBER           = 11;
const INFORMATIVE_TEXT       = 12;
const ZIP_CODE_EN            = 13;
const CITIZENSHIP            = 14;
const DATE_OF_BIRTH          = 15;
const CITIZENSHIP_EN         = 16;


// View steps
const GENERAL_STEP = 0;
const SCHOOL_SPECIFIC_STEP = 1;
const SUMMARY_STEP = 2;
const LOADING_STEP = 3;
const COMPLETED_STEP = 4;
const captcha_key_from_dom = captcha_key; // Captcha key, defined in the blade template
const csrf_token_from_dom = csrf_token; // CSRF token, defined in the blade template

export default {
    components: {
        'input-group': InputGroup,
        'course-selector': CourseSelector,
        'course-plus-selector': CoursePlusSelector,
        'draft-email-modal': DraftEmailModal,
    },
    setup() {
        const captcha_key = ref(captcha_key_from_dom);

        const { t, locale } = useI18n();
        locale.value = 'no';

        function getLanguage() {
            const url = new URL(window.location.href);
            const language = url.searchParams.get("language");

            if (language && language === "en") {
                locale.value = language;
            }
        }


        const submissionId = ref(null);
        const submissionEmail = ref('');
        const recieptUrl = ref('');

        const courseTypeError = ref(null);
        const courseType2Error = ref(null);

        const applicationFinished = ref(false);

        // *************************************************************************
        // Globals
        // *************************************************************************
        const globals = ref({});

        function getGlobals() {
            if (window.applicationFormData.globals) {
                globals.value = window.applicationFormData.globals;
                return;
            }
            return axios.get('/xhr/v1/frontend/globals')
                .then(response => {
                    globals.value = response.data;
                })
                .catch(error => {
                    Sentry.captureException(error);
                    console.log(error);
                });
        }

        function fixGlobalsTemplate() {
            if(globals.value.form_intro){
                const urlParams = (new URL(window.location.href)).searchParams;
                const courseParam = urlParams.get("courses");
                let englishApplicationLink = '/soknad?school=' + urlParams.get("school") + '&language=en';
                if (courseParam) {
                    englishApplicationLink += '&courses=' + courseParam;
                }
                globals.value.form_intro = globals.value.form_intro.replace("/[english_application]", englishApplicationLink);
                globals.value.form_intro = globals.value.form_intro.replace("[soknadsfrist_tekst]", globals.value.form_duedate_standard);
            }
            if(globals.value.form_outro) {
                globals.value.form_outro = globals.value.form_outro.replace("[skolenavn]", school.value.name);
            }
        }

        const outroText = computed(()=>{
            let outro = `${globals.value.form_outro}`;
            if([1,5,6,7,8].includes(selectedCourseType.value)){
                outro += globals.value.form_outro_apply_wholeyear;
            }
            if([2,3,4].includes(selectedCourseType.value)){
                outro += globals.value.form_outro_apply_halfyear;
            }
            return outro;
        });

        // *************************************************************************
        // School data
        // *************************************************************************
        const school = ref(null);
        function getSchool(){
            const url = new URL(window.location.href);
            let schoolId = url.searchParams.get("school");

            if (!schoolId && window.applicationFormData.selectedSchool) {
                schoolId = window.applicationFormData.selectedSchool;
            }

            applicationForm.school_id = schoolId;

            if (schoolId) {
                if (window.applicationFormData.schools[schoolId]) {
                    school.value = window.applicationFormData.schools[schoolId];
                    return;
                }


                return axios.get('/xhr/v1/frontend/schools/' + schoolId)
                    .then(response => {
                        school.value = response.data;
                        getSchoolUrl();
                    })
                    .catch(error => {
                        Sentry.captureException(error);
                        console.log(error);
                    });
            }
        }

        const schoolUrl = ref('');
        function getSchoolUrl(){
            if(localeIsEnglish.value){
                schoolUrl.value = `/school/${school.value.slug}`;
            } else {
                schoolUrl.value = `/skole/${school.value.slug}`;
            }
        }

        const schoolAcceptApplications = ref(true);
        function getSchoolAcceptApplications(){
            if(localeIsEnglish.value){
                schoolAcceptApplications.value = school.value.accept_english_applications;
            }
        }



        // *************************************************************************
        // Course data
        // *************************************************************************
        const schoolHasActiveCourses = ref(true);
        const courseTypes = ref([]);
        function getCourseTypes() {
            const halfyearAutumn = parseInt(globals.value.application_halfyear_autumn);
            const halfyearNextAutumn = halfyearAutumn + 1;
            const halfyearSpring = parseInt(globals.value.application_halfyear_spring);
            const halfyearNextSpring = halfyearSpring + 1;

            const courseTypesTemp = {};

            school.value.courses.forEach(course => {
                let courseTypeId = course.type.id;
                let courseTypeNameNo = course.type.name_no;
                let courseTypeNameEn = course.type.name_en;
                let courseYears = Object.values(course.years);

                // put courses with later start date than the selected next semester into its own choice
                if (courseYears.length === 1 && course.type.id === 3 && courseYears[0] == halfyearNextSpring) {
                    courseTypeId += '-a';
                    courseTypeNameNo += ' ' + halfyearNextSpring;
                    courseTypeNameEn += ' ' + halfyearNextSpring;
                }
                else if (courseYears.length === 1 && course.type.id === 2 && courseYears[0] == halfyearNextAutumn) {
                    courseTypeId += '-a';
                    courseTypeNameNo += ' ' + halfyearNextAutumn;
                    courseTypeNameEn += ' ' + halfyearNextAutumn;
                }

                if(!courseTypesTemp[courseTypeId]){
                    courseTypesTemp[courseTypeId] = {
                        id: courseTypeId,
                        name_no: courseTypeNameNo,
                        name_en: courseTypeNameEn,
                        courses: [],
                    };
                }

                courseTypesTemp[courseTypeId].courses.push(course);

                // put courses with start date also later than the selected next semester into its own choice additionally
                if (courseYears.length > 1 && course.type.id === 3 && Object.values(course.years).includes(halfyearNextSpring)) {
                    let courseTypeId = course.type.id + '-a';
                    if(!courseTypesTemp[courseTypeId]){
                        courseTypesTemp[courseTypeId] = {
                            id: courseTypeId,
                            name_no: course.type.name_no + ' ' + halfyearNextSpring,
                            name_en: course.type.name_en + ' ' + halfyearNextSpring,
                            courses: [],
                        };
                    }
                    courseTypesTemp[courseTypeId].courses.push(course);
                }
                else if (courseYears.length > 1 && course.type.id === 2 && Object.values(course.years).includes(halfyearNextAutumn)) {
                    let courseTypeId = course.type.id + '-a';
                    if(!courseTypesTemp[courseTypeId]){
                        courseTypesTemp[courseTypeId] = {
                            id: courseTypeId,
                            name_no: course.type.name_no + ' ' + halfyearNextAutumn,
                            name_en: course.type.name_en + ' ' + halfyearNextAutumn,
                            courses: [],
                        };
                    }
                    courseTypesTemp[courseTypeId].courses.push(course);
                }
            });

            if (school.value.concept === 'composite' && courseTypesTemp[2] && courseTypesTemp[3]) {
                courseTypesTemp.composite = {
                    id: 'composite',
                    name_no: 'Sammensatt linje av to halvårskurs',
                    name_en: 'Whole year course composed of two half year courses',
                    courses: [],
                };
            }

            courseTypes.value = courseTypesTemp;

            if(Object.keys(courseTypes.value).length == 0){
                schoolHasActiveCourses.value = false;
            }
        }


        // *************************************************************************
        // CoursePlus data
        // *************************************************************************
        const courseTypePlusError = ref(null);
        const selectedCoursesPlus = ref([0,]);
        function updateSelectedCoursesPlus(newSelectedCourses) {
            selectedCoursesPlus.value = newSelectedCourses;
            courseTypePlusError.value = null;
            applicationForm.input.coursesPlus = selectedCoursesPlus;
        }

        function getCoursePlusName(courseId) {
            let course = null;
            course = this.school?.coursesPlus.find(course => course.id == courseId);

            // set name of course
            let courseName = "";
            if (this.locale === "no") {
                courseName = course?.name_no;
            } else {
                courseName = course?.name_en;
                if (courseName === null || courseName === "") {
                    courseName = course.name_no;
                }
            }

            return courseName;
        }

        // *************************************************************************
        // Application form data
        // *************************************************************************
        const inputgroupsApplication = ref([]);
        function getApplicationFormGeneral() {
            const formId = locale.value === 'no' ? 1 : 2;

            return axios.get('/xhr/v1/admin/forms/' + formId)
                .then(response => {
                    response.data.inputgroups.forEach(inputgroup => {
                        inputgroupsApplication.value.push(inputgroup);
                    });
                })
                .catch(error => {
                    Sentry.captureException(error);
                    console.log(error);
                });
        }

        const inputgroupsSchool = ref([]);
        function getApplicationFormSchool() {
            return axios.get('/xhr/v1/frontend/schoolinputgroups/' + school.value.id, {
                params: {
                    language: locale.value
                }
            }).then(response => {
                response.data.inputgroups.forEach(inputgroup => {
                    inputgroupsSchool.value.push(inputgroup);
                });
            }).catch(error => {
                Sentry.captureException(error);
                console.log(error);
            });
        }

        const applicationForm = reactive({
            _token: csrf_token_from_dom,
            form_id: 1,
            school_id: null,
            status_id: 0,
            input: {
                options: [],
                values: {},
                courses: {},
                coursesPlus: [],
            },
            files: {},
            captchaToken: null,
        });
        const selectedCourseType = ref(null);
        const selectedCourses = reactive({0: [0,], 1: [0,]});

        const selectedCoursesData = ref([]);
        const selectedCourseQueryParam = ref('');

        function getCourseType(courseId){
            if(courseId){
                const foundCourse = school.value.courses.find(course => course.id == courseId)
                return foundCourse?.type.id;
            }
            // Fallback
            return parseInt(selectedCourseType);
        }

        function updateSelectedCoursesData(){
            // Remove any previous course types from the application form
            // This is forces the application form to only contain the selected course type
            // when the user changes the course type
            applicationForm.input.courses = {};
            if(!selectedCourseType.value) {
                selectedCourseType.value = 1;
            }
            applicationForm.input.courses[selectedCourseType.value] = selectedCourses;

            selectedCourseQueryParam.value = '';
            selectedCoursesData.value = [];

            let aggregateData = [];
            for (const index in [0,1]) {

                // Populate selectedCoursesData with the selected courses
                // If selected course is 0, don't add it to the selectedCoursesData
                if (selectedCourses[index].length === 1 && selectedCourses[index][0] === 0) {
                    continue;
                }

                let courseTypeData = null;
                const courseTypeId = getCourseType(selectedCourses[index][0]);
                courseTypeData = courseTypes.value[courseTypeId];

                let typeData = {
                    type: courseTypeData,
                    courses: []
                };

                const courses = selectedCourses[index].filter(course => course !== 0);
                courses.forEach(course => {
                    const courseData = school.value.courses.find(c => c.id === course);
                    if (courseData) {
                        selectedCoursesData.value.push(courseData);
                        typeData.courses.push(courseData);
                    }
                });

                aggregateData.push(typeData);

                selectedCourseQueryParam.value += (index === '0' ? '' : ';') + index + ':' + courses.join(',');
            }
            selectedCoursesData.value = aggregateData;

            const url = new URL(window.location.href);
            url.searchParams.set('courses', selectedCourseQueryParam.value);
            window.history.pushState({}, '', url);
        }

        function updateSelectedCourseType(typeId) {
            selectedCourseType.value = typeId;
            let selectedCoursesTemp = getSelectedCoursesFromUrl();
            if (!selectedCoursesTemp[0]) {
                return;
            }

            // todo: rework the flow so we don't have to get this from window
            if (!window.applicationFormData.schools) {
                return;
            }
            const schools = Object.values(window.applicationFormData.schools);
            if (!schools.length) {
                return;
            }
            const courses = schools[0].courses;
            const selectedCourse = courses.find(course => course.id == selectedCoursesTemp[0]);

            if (!selectedCourse) {
                return;
            }

            const courseType = selectedCourse.type.id;

            if (courseType === 7 || courseType === 9 || courseType === 11) {
                // if the application have been linked to from a "B" course we need to set the secondary course:
                selectedCourses[1] = selectedCoursesTemp[0] ? selectedCoursesTemp[0] : [0,];
            } else {
                selectedCourses[0] = selectedCoursesTemp[0] ? selectedCoursesTemp[0] : [0,];
            }
        }

        function updateSelectedCourses(newSelectedCourses) {
            selectedCourses[0] = newSelectedCourses[0];
            selectedCourses[1] = newSelectedCourses[1];
            courseTypeError.value    = null;
            courseType2Error.value   = null;

            waitinglistNotise();
        }

        const displayWaitinglistNotise = ref(false);
        function waitinglistNotise(){
            displayWaitinglistNotise.value = false;
            selectedCourses[0].forEach(courseId => {
                const foundCourse = school.value.courses.find(course => course.id === courseId);
                if(foundCourse && foundCourse.booking_status.id == 2){
                    displayWaitinglistNotise.value = true;
                }
            });
        }

        function getRequestedCourses() {
            const courseList = [];
            const url     = new URL(window.location.href);
            const courses = url.searchParams.get("courses");

            if (courses) {
                courses.split(';').forEach(course => {
                    if (course.indexOf(':') !== -1) {
                        const [index, courseIds] = course.split(':');
                        if (courseIds) {
                            courseList[index] = courseIds.split(',').map(Number);
                        }
                    } else {
                        courseList[0] = course.split(',').map(Number);
                    }
                });
            }

            if (school.value) {
                const schoolCourseIds = new Set(school.value.courses.map(c => c.id));
                const result = courseList.map(ids => ids?.filter(id => schoolCourseIds.has(id)));
                return result;
            } else {
                return courseList;
            }
        }

        function getSelectedCoursesFromUrl() {
            const courseList = getRequestedCourses();
            let val = reactive({0: courseList[0] ? courseList[0] : [0,], 1: courseList[1] ? courseList[1] : [0,]});
            return val;
        }

        function getFirstCourseFromRequest() {
            const courseList = getRequestedCourses();
            if (!courseList[0]) {
                return null;
            }
            let firstCourseFromRequest = courseList[0][0];
            return school.value.courses.find(course => course.id === firstCourseFromRequest);
        }

        function getSelectedCourseType() {
            let firstCourse = getFirstCourseFromRequest();
            if (firstCourse) {
                let typeId = firstCourse.type.id;
                if (typeId === 7) {
                    typeId = 6;
                } else if (typeId === 9) {
                    typeId = 8;
                } else if (typeId === 11) {
                    typeId = 10;
                }
                return typeId;
            } else {
                return null;
            }
        }

        function updateInputGroup(inputGroupCollection, inputId, value) {
            inputGroupCollection.forEach(inputGroup => {
                inputGroup.inputs.forEach(input => {
                    if (input.id === inputId) {
                        input.value = value;
                    }
                });
            });
        }

        function getInputValue(inputId){
            let inputValue = null;

            inputgroupsApplication.value.forEach(inputGroup => {
                inputGroup.inputs.forEach(input => {
                    if (input.id === inputId) {
                        inputValue = input.value;
                    }
                });
            });
            inputgroupsSchool.value.forEach(inputGroup => {
                inputGroup.inputs.forEach(input => {
                    if (input.id === inputId) {
                        inputValue = input.value;
                    }
                });
            });

            return inputValue;
        }

        function updateInputValue(inputId, value) {
            updateInputGroup(inputgroupsApplication.value, inputId, value);
            updateInputGroup(inputgroupsSchool.value, inputId, value);

            if(value == "" && inputId in applicationForm.input.values){
                delete applicationForm.input.values[inputId];
            } else if (value != "") {
                applicationForm.input.values[inputId] = value;
            }
            inputgroupsApplication.value.forEach(inputgroup => {
                inputgroup.inputs.forEach(input => {
                    if (input.id === inputId) {
                        input.error = '';
                    }
                });
            });
        }

        function updateInputOptions(inputOptions, selectedOptions) {
            // Remove any previous options from the application form
            inputOptions.forEach(option => {
                const index = applicationForm.input.options.indexOf(option);
                if (index > -1) { // only splice array when item is found
                    applicationForm.input.options.splice(index, 1); // 2nd parameter means remove one item only
                }
                // find associated input and remove it's error
                inputgroupsApplication.value.forEach(inputgroup => {
                    inputgroup.inputs.forEach(input => {
                        if (input.type_id === SELECT || input.type_id === RADIO || input.type_id === CHECKBOX) {
                            input.inputoptions.forEach(inputoption => {
                                if (inputoption.id === option) {
                                    input.error = '';
                                }
                            });
                        }
                    });
                });
            });

            // Add the selected options to the application form
            if(selectedOptions != "0"){
                applicationForm.input.options = applicationForm.input.options.concat(selectedOptions);
            }
        }

        function validateForm() {
            let validated = true;
            let scrolled  = false;

            // Validate selected course
            if (selectedCourses[0][0] === 0) {
                validated = false;
                courseTypeError.value = t('formErrorCourse');
                scrolled = scrolled ? true : scrollIntoView('.courseSelector__container');
            }

            // Validate secondary course for schools with a/b courses
            if (
                (selectedCourseType.value === 6 || selectedCourseType.value === 8 || selectedCourseType.value === 10) &&
                selectedCourses[1][0] === 0) {
                validated = false;
                courseType2Error.value = t('formErrorCourse');
                scrolled = scrolled ? true : scrollIntoView('.courseSelector--secondary');
            }


            // Validate all fields in inputgroups
            let inputGroups = inputgroupsApplication.value;
            if (applicationStep.value > 0) {
                inputGroups = inputGroups.concat(inputgroupsSchool.value);
            }
            for (const inputGroup of inputGroups) {
                for (const input of inputGroup.inputs) {
                    const validationResult = validateInput(applicationForm, input, t);

                    input.error = validationResult.error;
                    if(!validationResult.validated){
                        validated = false;
                        scrolled = scrolled ? true : scrollIntoView(`#input_${input.id}`);
                    }
                }
            }
            return validated;
        }





        function viewApplication() {
            const url = new URL(window.location.href);
            const submissionIdFromUrl = url.searchParams.get("view");
            if (submissionIdFromUrl) {
                // Get the submission data, and populate the form with the data
                return axios.get('/xhr/v1/frontend/submissions/' + submissionIdFromUrl)
                    .then(response => {
                        submissionId.value = response.data.id;

                        const data = response.data;
                        const inputValues = {};
                        for (const input of data.inputvalues) {
                            updateInputValue(input.input_id, input.value);
                        }

                        let selectedCoursesTemp = reactive({0:[],1:[]});

                        selectedCourseType.value = data.inputcourses[0].type_id;
                        for (const input of data.inputcourses) {
                            const courseType = getCourseType(input.course_id);
                            if( courseType == 6) { // Full year course B
                                selectedCoursesTemp[1].push(input.course_id);
                            } else {
                                selectedCoursesTemp[0].push(input.course_id);
                            }
                        }

                        // console.log(selectedCoursesTemp);
                        updateSelectedCourses(selectedCoursesTemp);
                        updateSelectedCoursesPlus(data.inputcoursesplus.map(course => course.course_id));


                    })
                    .catch(error => {
                        Sentry.captureException(error);
                        console.log(error);
                        if(error.response.status === 403){
                            alert(t('draftErrorSubmitted'));
                            window.location.href = '/soknad';
                        }
                    });
            }
        }

        function addFileToForm(inputId, fileIndex, file) {
            // Handle missing inputField array
            if(!applicationForm.files[inputId]){
                applicationForm.files[inputId] = [];
            }

            // Add or modify file binary to form
            applicationForm.files[inputId][fileIndex] = file;

            // Get current value
            const inputValueRaw = getInputValue(inputId);
            let inputValue = [];
            if(inputValueRaw){
                inputValue = JSON.parse(inputValueRaw);
            }

            // Update value
            if(inputValue){
                inputValue[fileIndex] = file.name;
            }
            const inputValueJSON = JSON.stringify(inputValue);
            updateInputValue(inputId, inputValueJSON);
        }

        function saveApplication(status_id = 1){
            applicationForm.status_id = status_id;
            applicationForm.form_id = locale.value == 'en' ? 2 : 1;
            applicationForm.sourceValue = window.localStorage.applicationSource ?? '';
            if (submissionId.value) {
                const url = '/xhr/v1/frontend/submissions/' + submissionId.value;
                const settings = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                };
                applicationForm._method = 'PATCH';
                axios.post(url, applicationForm, settings)
                    .then(response => {
                        if(response.status === 200) {
                            submissionId.value = response.data.submission.id;

                            if (window.snaptr) {
                                const snapEvent = (status_id === 1) ? 'SIGN_UP' : 'ADD_CART';

                                console.log('application snap event: ' + snapEvent);

                                snaptr('track', snapEvent);
                            } else {
                                console.log('no snaptr event');
                            }

                            getRecieptUrl();
                            // If the submission was successfully submitted show confirmation page or redirect to custom confirmation page
                            if (status_id === 1) {
                                applicationFinished.value = true; // disables unload event
                                if (locale.value === 'en' && school.value.confirmationPageEn) {
                                    location.href = school.value.confirmationPageEn;
                                } else if (school.value.confirmationPage) {
                                    location.href = school.value.confirmationPage;
                                } else {
                                    viewNext();
                                }
                            }
                        }
                    })
                    .catch(error => {
                        Sentry.captureException(error);
                        console.log(error);
                        if (status_id === 1) {
                            // if failing on last step, go back to summary
                            // TODO: show error message
                            viewBack();
                        }
                    });
            } else {
                const url = '/xhr/v1/frontend/submissions/';
                const settings = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                };
                axios.post(url, applicationForm, settings)
                    .then(response => {
                        if(response.status === 201){
                            submissionId.value = response.data.submission.id;
                            getRecieptUrl();
                        }

                    })
                    .catch(error => {
                        Sentry.captureException(error);
                        console.log(error);
                    });
            }
        }

        function getRecieptUrl(){
            const url = new URL(window.location.href);
            recieptUrl.value = `${url.protocol}//${url.host}/soknad/${submissionId.value}/kvittering?language=${locale.value}`;
        }

        async function sendDraftEmail(email){
            if (submissionId.value) {
                const url = '/xhr/v1/frontend/mail/applications/draft';
                const settings = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                };
                const data = {
                    _token: csrf_token,
                    id: submissionId.value,
                    email: email,
                    captchaToken: await validateCapcha(captcha_key.value),
                };
                axios.post(url, data, settings)
                    .then(response => {
                        if(response.status === 200){
                            draftModalOpen.value = false;
                        }
                    })
                    .catch(error => {
                        Sentry.captureException(error);
                        console.log(error);
                    });
            }
        }


        const draftModalOpen = ref(false);

        function openDraftModal(event){
            event.preventDefault();
            if(locale.value === 'no' && applicationForm.input.values['27']){
                submissionEmail.value = applicationForm.input.values['27'];
            }
            if(locale.value === 'en' && applicationForm.input.values['47']){
                submissionEmail.value = applicationForm.input.values['47'];
            }

            draftModalOpen.value = true;
        }

        onBeforeMount(() => {
            getSchool();
            getData();
        });

        async function getData() {
            getLanguage();
            await getApplicationFormGeneral();
            await getGlobals();
            // await getSchool();
            await fixGlobalsTemplate();

            getSchoolAcceptApplications();
            getCourseTypes();
            selectedCourseType.value = getSelectedCourseType();

            await getApplicationFormSchool();
            await viewApplication();
            // globals.value.form_intro = "yo";
        }



        // *************************************************************************
        // Form steps
        // *************************************************************************
        const applicationStep = ref(0);

        // Functionality to stop users from accidentally leaving a form they have started working on
        const clickedIntroButton = ref(false);

        window.addEventListener("beforeunload", (event) =>{
            if(applicationStep.value !== COMPLETED_STEP && !applicationFinished.value && !clickedIntroButton.value){
                event.preventDefault();
            }
        });

        async function viewNext(){
            if(validateForm()){
                updateSelectedCoursesData();
                applicationForm.captchaToken = await validateCapcha(captcha_key.value);

                if (applicationStep.value === GENERAL_STEP) {
                    if(this.inputgroupsSchool.length > 0) {
                        viewSchoolSpecificStep();
                    } else {
                        viewSummaryStep();
                    }
                    saveApplication(0);
                } else if (applicationStep.value === SCHOOL_SPECIFIC_STEP) {
                    viewSummaryStep();
                    saveApplication(0);
                } else if(applicationStep.value === SUMMARY_STEP) {
                    applicationStep.value = LOADING_STEP;
                    if (window.plausible) {
                        plausible("Fullført søknad", school.value.name);
                    } else {
                        console.log(`tracking "fullført søknad" for ${school.value.name} to plausible`);
                    }
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            'event': 'Fullført søknad',
                            'school': this.school.id
                        });
                    }
                    else {
                        console.log({
                            'event': 'Fullført søknad',
                            'school': this.school.id
                        });
                    }
                    saveApplication(1);
                } else if(applicationStep.value === LOADING_STEP) {
                    applicationStep.value = COMPLETED_STEP;
                }
                window.scrollTo(0, 0);
            }
        }

        async function viewBack(){
            if(validateForm()){
                updateSelectedCoursesData();
                applicationForm.captchaToken = await validateCapcha(captcha_key.value);

                if (applicationStep.value === SCHOOL_SPECIFIC_STEP) {
                    viewGeneralStep();
                } else if (applicationStep.value === SUMMARY_STEP) {
                    if(inputgroupsSchool.value.length > 0)
                        viewSchoolSpecificStep();
                    else
                        viewGeneralStep();
                } else if(applicationStep.value === LOADING_STEP) {
                    applicationStep.value = SUMMARY_STEP;
                } else if(applicationStep.value === COMPLETED_STEP) {
                    applicationStep.value = SUMMARY_STEP;
                }
                saveApplication(0);
            }
        }


        function viewGeneralStep(){
            applicationStep.value = 0;
            scrollTop();
        }

        function viewSchoolSpecificStep(){
            applicationStep.value = 1;
            scrollTop();
        }

        function viewSummaryStep(){
            applicationStep.value = 2;
            scrollTop();
        }

        function getSelectedOptions(inputGroup){
            let result = [];
            inputGroup.forEach(group=>{
                if(applicationForm.input.options.includes(group.id)){
                    result.push(group.text)
                }
            });
            return result;
        };

        const hideStep0 = computed(() => {
            return applicationStep.value === 0 ? '' : 'hidden';
        });

        const hideStep1 = computed(() => {
            return applicationStep.value === 1 ? '' : 'hidden';
        });

        const hideStep2 = computed(() => {
            return applicationStep.value === 2 ? '' : 'hidden';
        });

        const hideStep3 = computed(() => {
            return applicationStep.value === 3 ? '' : 'hidden';
        });

        const hideStep4 = computed(() => {
            return applicationStep.value === 4 ? '' : 'hidden';
        });

        const localeIsEnglish = computed(() => {
            return locale.value === 'en';
        });

        const getDraftUrl = computed(() => {
            const url = new URL(window.location.href);
            if(submissionId.value){
                return `${url.protocol}//${url.host}${url.pathname}/${submissionId.value}`;
            } else {
                return "";
            }
        });

        return {
            captcha_key,
            locale,
            globals,
            applicationStep,
            submissionId,
            submissionEmail,
            recieptUrl,
            school,
            schoolUrl,
            courseTypes,
            schoolHasActiveCourses,
            inputgroupsApplication,
            inputgroupsSchool,
            selectedCourseType,
            courseTypeError,
            courseType2Error,
            selectedCourses,
            selectedCoursesData,

            selectedCoursesPlus,
            courseTypePlusError,
            updateSelectedCoursesPlus,
            getCoursePlusName,

            draftModalOpen,
            applicationForm,
            scrollIntoView,
            sendDraftEmail,
            openDraftModal,
            addFileToForm,
            viewNext,
            viewBack,
            updateSelectedCourses,
            updateInputOptions,
            updateSelectedCourseType,
            updateInputValue,
            hideStep0,
            hideStep1,
            hideStep2,
            hideStep3,
            hideStep4,
            localeIsEnglish,
            getDraftUrl,
            getSelectedOptions,
            outroText,
            displayWaitinglistNotise,
            clickedIntroButton,
            schoolAcceptApplications,
        }
    }
}
</script>